import React, { useState } from 'react';
import { Modal, Button, Checkbox, Col, Row } from 'antd';
import { withTranslation } from 'react-i18next';

import ButtonClose from '../../common/UI/ButtonClose';
import { VIEW_MODES, VIEW_MODE_ICONS, VIEW_MODE_COLORS, EXCLUDED_VIEW_MODES } from '../../../configs/viewSettings';
import styles from './pasteViewSettings.less';
import modalStyles from '../../common/Modal/modal.less';

const PasteViewSettings = (props) => {
  const { t, currentMode, onOk, onCancel } = props;

  const modeOrder = Object.values(VIEW_MODES).filter((mode) => !Object.values(EXCLUDED_VIEW_MODES).includes(mode));

  const [selected, setSelected] = useState(() => (currentMode && modeOrder.includes(currentMode) ? [currentMode] : []));

  const allChecked = selected.length === modeOrder.length;
  const indeterminate = selected.length > 0 && !allChecked;

  const toggleAll = (e) => setSelected(e.target.checked ? [...modeOrder] : []);

  const onApply = () => {
    if (selected.length === 0) return;
    onOk && onOk(selected);
  };

  const buttons = [
    <Button key="submit" type="primary" onClick={onApply} disabled={selected.length === 0}>
      {t('modals.pasteViewSettingsConfirm.okText')}
    </Button>,
    <Button key="back" type="default" onClick={onCancel}>
      {t('modals.pasteViewSettingsConfirm.cancelText')}
    </Button>,
  ];

  return (
    <Modal open maskClosable={false} closable={false} footer={buttons} width={480}>
      <Row type="flex" justify="space-between" align="middle" className={modalStyles.header}>
        <h1>{t('modals.pasteViewSettingsConfirm.headerText')}</h1>
        <ButtonClose large className={modalStyles.close} shiftRight onClick={onCancel} />
      </Row>
      <Col className={modalStyles.content}>
        <div className={styles.description}>{t('modals.pasteViewSettingsConfirm.description')}</div>

        <div className={styles.selectAll}>
          <Checkbox checked={allChecked} indeterminate={indeterminate} onChange={toggleAll}>
            {t('modals.pasteViewSettingsConfirm.selectAll')}
          </Checkbox>
        </div>

        <Checkbox.Group value={selected} onChange={setSelected} style={{ width: '100%' }}>
          <div className={styles.grid}>
            {modeOrder.map((key) => {
              const Icon = VIEW_MODE_ICONS[key];
              const color = VIEW_MODE_COLORS[key];
              return (
                <Checkbox key={key} value={key}>
                  <span className={styles.itemLabel}>
                    {Icon && <Icon className={styles.itemIcon} style={{ color }} />}
                    <span className={styles.itemText}>{t(`views.modal.viewModes.${key}`)}</span>
                    {key === currentMode && (
                      <span className={styles.currentTag}>{t('modals.pasteViewSettingsConfirm.currentLabel')}</span>
                    )}
                  </span>
                </Checkbox>
              );
            })}
          </div>
        </Checkbox.Group>
      </Col>
    </Modal>
  );
};

export default withTranslation()(PasteViewSettings);
